<template>
  <div id="navbar">
    <button class="kt-aside-close" id="kt_aside_close_btn">
      <i class="la la-close"></i>
    </button>
    <div
      class="kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop"
      id="kt_aside"
    >
      <div class="kt-aside__brand kt-grid__item" id="kt_aside_brand">
        <div class="kt-aside__brand-logo">
          <a href="/">
            <img alt="Logo" src="static/assets/media/logos/logo-text-light.png">
          </a>
        </div>
        <div class="kt-aside__brand-tools">
          <button class="kt-aside__brand-aside-toggler" id="kt_aside_toggler">
            <!-- <span class="kt-menu__link-icon"> -->
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect id="bound" x="0" y="0" width="24" height="24"/>
                      <rect id="Rectangle-7" fill="#000000" opacity="0.3" x="4" y="4" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-3" fill="#000000" x="4" y="10" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy" fill="#000000" x="10" y="4" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-4" fill="#000000" x="10" y="10" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-2" fill="#000000" x="16" y="4" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-5" fill="#000000" x="16" y="10" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-8" fill="#000000" x="4" y="16" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-7" fill="#000000" x="10" y="16" width="4" height="4" rx="2"/>
                      <rect id="Rectangle-7-Copy-6" fill="#000000" x="16" y="16" width="4" height="4" rx="2"/>
                  </g>
              </svg>
            <!-- </span> -->
          </button>
        </div>
      </div>
      <MenuList/>
    </div>
    <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
      <!-- begin:: Header -->
      <div id="kt_header" class="kt-header kt-grid__item kt-header--fixed" style="border-color: #f9f9f9;">
        <!-- begin:: Header Menu -->
        <button class="kt-header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn">
          <i class="la la-close"></i>
        </button>
        <div class="kt-header-menu-wrapper" id="kt_header_menu_wrapper">
          <div
            id="kt_header_menu"
            class="kt-header-menu kt-header-menu-mobile kt-header-menu--layout-default"
          >
            <ul class="kt-menu__nav">
              <li
                class="kt-menu__item kt-menu__item--submenu kt-menu__item--rel"
              >
                <!-- <div class="kt-menu__link bg-secondary" style="cursor: default;">
                  <span class="kt-menu__link-text text-primary"><i class="fab fa-chromecast"></i>&nbsp;{{ $route.meta.title }}</span>
                  <i class="kt-menu__ver-arrow la la-angle-right"></i>
                </div> -->
                <div class="kt-subheader__main">
                  <h3 class="kt-subheader__title text-info" style="margin: 0px; padding: 0px;">
                    <span><i class="fas fa-map-marker-alt"></i>&nbsp;{{ $route.meta.title }} </span>
                   </h3>
                  <!-- <span class="kt-subheader__separator kt-hidden"></span> -->
                  <!-- <div class="kt-subheader__breadcrumbs">
                    <a href="javascript:void(0)" class="kt-subheader__breadcrumbs-home"><i class="flaticon2-shelter"></i></a>
                    <span class="kt-subheader__breadcrumbs-separator"></span>
                    <a href="" class="kt-subheader__breadcrumbs-link">
                      Components </a>
                    <span class="kt-subheader__breadcrumbs-separator"></span>
                    <a href="" class="kt-subheader__breadcrumbs-link">
                      Icons </a>
                    <span class="kt-subheader__breadcrumbs-separator"></span>
                    <a href="" class="kt-subheader__breadcrumbs-link">
                      Fontawesome 5 </a>
                      <span class="kt-subheader__breadcrumbs-link kt-subheader__breadcrumbs-link--active">Active link</span> -->
                  <!-- </div> --> 
                </div>
                <!-- <div class="kt-menu__submenu kt-menu__submenu--classic kt-menu__submenu--left">
                  <ul class="kt-menu__subnav">
                    <li class="kt-menu__item" aria-haspopup="true">
                      <a href="javascript:;" class="kt-menu__link">
                        <span class="kt-menu__link-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                            class="kt-svg-icon"
                          >
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M8,17 C8.55228475,17 9,17.4477153 9,18 L9,21 C9,21.5522847 8.55228475,22 8,22 L3,22 C2.44771525,22 2,21.5522847 2,21 L2,18 C2,17.4477153 2.44771525,17 3,17 L3,16.5 C3,15.1192881 4.11928813,14 5.5,14 C6.88071187,14 8,15.1192881 8,16.5 L8,17 Z M5.5,15 C4.67157288,15 4,15.6715729 4,16.5 L4,17 L7,17 L7,16.5 C7,15.6715729 6.32842712,15 5.5,15 Z"
                                id="Mask"
                                fill="#000000"
                                opacity="0.3"
                              ></path>
                              <path
                                d="M2,11.8650466 L2,6 C2,4.34314575 3.34314575,3 5,3 L19,3 C20.6568542,3 22,4.34314575 22,6 L22,15 C22,15.0032706 21.9999948,15.0065399 21.9999843,15.009808 L22.0249378,15 L22.0249378,19.5857864 C22.0249378,20.1380712 21.5772226,20.5857864 21.0249378,20.5857864 C20.7597213,20.5857864 20.5053674,20.4804296 20.317831,20.2928932 L18.0249378,18 L12.9835977,18 C12.7263047,14.0909841 9.47412135,11 5.5,11 C4.23590829,11 3.04485894,11.3127315 2,11.8650466 Z M6,7 C5.44771525,7 5,7.44771525 5,8 C5,8.55228475 5.44771525,9 6,9 L15,9 C15.5522847,9 16,8.55228475 16,8 C16,7.44771525 15.5522847,7 15,7 L6,7 Z"
                                id="Combined-Shape"
                                fill="#000000"
                              ></path>
                            </g>
                          </svg>
                        </span>
                        <span class="kt-menu__link-text">Reporting</span>
                      </a>
                    </li>
                  </ul>
                </div> -->
              </li>
            </ul>
          </div>
        </div>
        <!-- end:: Header Menu -->

        <!-- begin:: Header Topbar -->
        <div class="kt-header__topbar">
          <!-- <div
            class="kt-header__topbar-item kt-header__topbar-item--search dropdown"
            id="kt_quick_search_toggle"
          >
            <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="10px,0px">
              <span class="kt-header__topbar-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  class="kt-svg-icon"
                >
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                      id="Path-2"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                    ></path>
                    <path
                      d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                      id="Path"
                      fill="#000000"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </svg>
              </span>
            </div>
            <div
              class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-lg"
            >
              <div class="kt-quick-search kt-quick-search--inline" id="kt_quick_search_inline">
                <form method="get" class="kt-quick-search__form">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="flaticon2-search-1"></i>
                      </span>
                    </div>
                    <input
                      type="text"
                      class="form-control kt-quick-search__input"
                      placeholder="Search..."
                    >
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-close kt-quick-search__close"></i>
                      </span>
                    </div>
                  </div>
                </form>
                <div
                  class="kt-quick-search__wrapper kt-scroll"
                  data-scroll="true"
                  data-height="300"
                  data-mobile-height="200"
                ></div>
              </div>
            </div>
          </div> -->
          <div class="kt-header__topbar-item kt-header__topbar-item--user">
            <div class="kt-header__topbar-wrapper" data-toggle="dropdown" data-offset="0px,0px">
              <div class="kt-header__topbar-user">
                <span class="kt-header__topbar-welcome">Hi,</span>
                <span class="kt-header__topbar-username">{{ $store.state.user.username }}</span>
                <img alt="Pic" src="static/assets/img/users/default.jpg">
                <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
                <!-- <span
                  class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"
                v-if="$store.state.user.role_id == 1" >A</span>
                <span
                  class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"
                v-if="$store.state.user.role_id == 2" >M</span>
                <span
                  class="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold"
                v-if="$store.state.user.role_id == 3" >O</span> -->
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl"
            >
              <!--begin: Head -->
              <div
                class="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                style="background-image: url(static/assets/img/misc/bg-1.jpg)"
              >
                <div class="kt-user-card__avatar">
                  <img alt="Pic" src="static/assets/img/users/default.jpg">
                  <!--use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) -->
                  <!-- <span
                    class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"
                    v-if="$store.state.user.role_id == 1"
                  >A</span>
                  <span
                    class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"
                    v-if="$store.state.user.role_id == 2"
                  >M</span>
                  <span
                    class="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success"
                    v-if="$store.state.user.role_id == 3"
                  >O</span> -->
                </div>
                <div class="kt-user-card__name">{{ $store.state.user.fname }}
                  &nbsp;{{ $store.state.user.lname }}</div>
                <!--                                <div class="kt-user-card__badge">
                                    <span class="btn btn-success btn-sm btn-bold btn-font-md">23 messages</span>
                </div>-->
              </div>
              <!--end: Head -->
              <!--begin: Navigation -->
              <div class="kt-notification">
                <a href="/profile" class="kt-notification__item">
                  <div class="kt-notification__item-icon">
                    <i class="flaticon2-calendar-3 kt-font-success"></i>
                  </div>
                  <div class="kt-notification__item-details">
                    <div class="kt-notification__item-title kt-font-bold">My {{ $store.state.user.fname }}&nbsp;{{ $store.state.user.lname }}</div>
                    <div class="kt-notification__item-time">  ข้อมูลผู้ใช้งานระบบ</div>
                  </div>
                </a>
                <div class="kt-notification__custom kt-space-between">
                  <span></span>
                   <a 
                    href="javascript:void(0)"
                    class="btn btn-label btn-label-brand btn-sm btn-bold"
                    @click="logout()"
                  ><i class="fas fa-sign-out-alt"></i> ออกจากระบบ</a>
                  <!--<a href="demo1/custom/user/login-v2.html" target="_blank" class="btn btn-clean btn-sm btn-bold">ออกจากระบบ</a>-->
                </div>
                
              </div>
              <!--end: Navigation -->
            </div>
          </div>
          <!--end: User Bar -->
        </div>
        <!-- end:: Header Topbar -->
      </div>
      <!-- end:: Header -->
    </div>
  </div>
</template>

<script>
import api from '../../service/service.js'
import MenuList from '@/components/layout/navbar_menu'
export default {
  components: {
    MenuList
  },
  data () {
    return {}
  },
  methods: {
    getmenu () {
      // this.menu = this.$store.state.user.menus
      // this.menu = localStorage.Menus
    },
    editprofile () {
      window.location.href = '/profile'
    },
    logout () {
      api.Logout()
      this.$router.push({name: 'Login'})
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/navbar.vue